module.exports = __webpack_public_path__ + "static/img/statusCorrectStaticDusty.fdad5a0f.png";